import {useTranslation} from 'react-i18next'
import {Card, CardBody} from 'reactstrap'

import {useFormDirty} from '../../contexts/FormDirtyContext'
import '../../styles.scss'
import ActionButtons from './components/ActionButtons'
import InfoItem from './components/InfoItem'
import ProductHeader from './components/ProductHeader'
import ProductImage from './components/ProductImage'

const ArticleProductCard = ({
  product,
  margin,
  lastAcquisition,
  baseValue,
  additionalPrice,
  isSaving,
  animate = true
}) => {
  const {t} = useTranslation()
  const {isDirty: isDirty} = useFormDirty()

  const productCoverImage =
    product?.productPropertiesSection?.productImage?.find(image => image.cover)

  return (
    <Card className={`${animate && 'card-animate'} m-4 card-articles-details`}>
      <CardBody className="cardbody-articles-details d-flex">
        <ProductImage
          imageUrl={productCoverImage?.image?.url || undefined}
          altText={product?.name}
        />

        <div className="box">
          <ProductHeader
            productName={
              product?.productPropertiesSection?.productTranslation[0]?.name
            }
            referenceCode={product?.referenceCode}
          />

          <div className="flex-grow-1 d-flex lower-row">
            <div className="d-flex gap-3">
              <InfoItem
                iconName="PriceIcon"
                label={`${t('PRICE')} (${t('WITHOUT')} vat):`}
                value={baseValue}
                suffix="€"
                additionalPrice={additionalPrice}
              />
            </div>

            <div className="d-flex gap-4 box-items">
              <InfoItem
                iconName="GrossMargin"
                label="Gross Margin:"
                value={
                  product?.productPriceSection?.marginPercentage?.toFixed(2) ||
                  margin ||
                  '-'
                }
                suffix="%"
              />

              <InfoItem
                iconName="AquisitionPrice"
                label="Last Acquisition Price"
                value={product?.lastacquisitionprice ?? lastAcquisition}
                suffix="€"
              />

              <InfoItem
                iconName="PCM"
                label="PCM PHC:"
                value={product?.pcm_phc ?? '-'}
              />

              <ActionButtons isSaving={isSaving} disabled={!isDirty} />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default ArticleProductCard
